import { FieldValidator } from 'final-form'

// import here all validator functions from validate
import { equals, isEmail, toDate } from 'validator'

import { isPresent } from '../../app/shared'
import { isString } from './utils'

type ValidationKeys = {
  required: string
  mustBeNumber: string
  minValue: string
  maxValue: string
  minLen: string
  maxLen: string
  email: string
  date: string
  notEqual: string
}

export const createValidators = (i18nKeys: ValidationKeys) => {
  return {
    required: (value: any) => (value ? undefined : i18nKeys.required),
    requiredArray: (value?: any[]) => (isPresent(value) && value.length > 0 ? undefined : i18nKeys.required),
    mustBeNumber: (value: any) => (isNaN(value) ? i18nKeys.mustBeNumber : undefined),
    minLen: (min: number) => (value: any) =>
      isString(value) && value.length >= min ? undefined : `${i18nKeys.minLen} ${min}`,
    maxLen: (max: number) => (value: any) =>
      isString(value) && value.length <= max ? undefined : `${i18nKeys.maxLen} ${max}`,
    minValue: (min: number) => (value: any) =>
      isNaN(value) || value >= min ? undefined : `${i18nKeys.minValue} ${min}`,
    maxValue: (max: number) => (value: any) =>
      isNaN(value) || value <= max ? undefined : `${i18nKeys.maxValue} ${max}`,
    email: (value: any) => (isEmail(value) ? undefined : `${i18nKeys.email}`),
    date: (value: any) => (toDate(value) ? undefined : `${i18nKeys.date}`),
    notEqual: (notEqualTo: any, value: any, message: string) => (!equals(notEqualTo, value) ? undefined : message),
  }
}

/**
 *
 * @param validators
 *
 * @example
 * ```ts
 * import {comsposeValidators} from 'modules/forms'
 * import {coreValidators} from '../shared'
 *
 * export const validators = {
 *  email: composeValidators(value, coreValidators.required, coreValidators.email),
 *  age: composeValidators(value, coreValidators.required, coreValidators.minValue(18))
 * }
 *
 * // form.tsx
 * <Field name={field.email} validate={validators.email} component="input"/>
 * <Field name={field.age} validate={validators.age} component="input"/>
 * ```
 */
export const composeValidators = (value: any, ...validators: any[]) =>
  validators.reduce((error, validator) => error || validator(value), undefined)

export type ValidatorsMap<T extends string> = Readonly<Record<T, FieldValidator>>

type DisableFieldValidatorFn = (disabled: boolean) => FieldValidator
export type ValidatorsMapDisabled<T extends string> = Readonly<Record<T, DisableFieldValidatorFn>>

export { FieldValidator }



// WEBPACK FOOTER //
// ./src/modules/forms/validators.ts